import React from 'react';

const Header = props => {
  return (
    <div className="title-container">
      <div className="flex-title">
        <div>
          <h2>{props.language.header.title}</h2>
        </div>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/account_list/header.jsx